import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "@/firebase/config";

export const PAYMENT_URL = process.env.REACT_APP_PAYMENT_URL || "#order";
export const LAUNCH_COUPON_CODE = "MBA10";
export const LAUNCH_COUPON_DISCOUNT = "10%";
export const LAUNCH_COUPON_LIMIT = "first 500 loyal users";

const LEAD_STORAGE_KEY = "noteConsoleOrderLead";

export function saveOrderLead(lead) {
  try {
    window.localStorage.setItem(LEAD_STORAGE_KEY, JSON.stringify(lead));
  } catch {
    // localStorage can be blocked; click tracking still works without it.
  }
}

export function getSavedOrderLead() {
  try {
    return JSON.parse(window.localStorage.getItem(LEAD_STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
}

export async function trackOrderClick(source, extra = {}) {
  const lead = extra.lead || getSavedOrderLead();
  await addDoc(collection(db, "orderClicks"), {
    source,
    page: window.location.pathname + window.location.hash,
    paymentUrl: PAYMENT_URL,
    leadName: lead.name || "",
    leadEmail: lead.email || "",
    plannerPreference: lead.plannerPreference || "",
    couponCode: lead.couponCode || LAUNCH_COUPON_CODE,
    ...extra,
    lead,
    clickedAt: serverTimestamp(),
  });
}

export function trackOrderClickQuietly(source, extra = {}) {
  trackOrderClick(source, extra).catch((error) => {
    console.error("Order click tracking failed:", error);
  });
}

export function openPaymentTab() {
  const paymentTab = window.open(PAYMENT_URL, "_blank", "noopener,noreferrer");
  if (!paymentTab) {
    window.location.href = PAYMENT_URL;
  }
}
